import { STORE_ALERT_SUMMARY, STORE_ALERTS } from '../../constants/alerts';

const initialState = {
  alertEntries: [],
  // Counts for the navbar badge, kept separate from alertEntries: the
  // badge is always on screen, the rows are only needed once someone
  // opens the drawer.
  alertSummary: {
    count: 0,
    noClearSubjectCount: 0,
    latestDecisionAlertId: null,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case STORE_ALERTS:
      return {
        ...state,
        alertEntries: action.alertEntries,
      };

    case STORE_ALERT_SUMMARY:
      return {
        ...state,
        alertSummary: action.alertSummary || initialState.alertSummary,
      };

    default:
      return state;
  }
};
